export const colors = {
  brandColor: "#0BD4A2",
};
